import React from 'react';
const modules = [{
  title: 'Dance Foundations',
  description: 'The solid base for confident, safe and engaging teaching.'
}, {
  title: 'Movement Library System',
  description: 'Your complete encyclopedia of movements, drills and combinations.'
}, {
  title: 'Class Builder Framework',
  description: 'Ready-to-use planning system to build any class in minutes.'
}, {
  title: 'Ready-to-Teach Class Collection',
  description: '30 complete classes ready to deliver today.'
}, {
  title: 'Progressive Dance Programs',
  description: 'Guide every student through real, visible results.'
}, {
  title: 'Professional Instructor Toolkit',
  description: 'The tools to teach with authority, structure and presence.'
}];
export function TomiSection() {
  return <section className="py-6 px-4 sm:px-6 bg-white border-y-4 border-brand-beige" data-id="element-170" data-mp="2hmhzw3n6r92c">
      <div className="text-center mb-4" data-id="element-171" data-mp="2dn0sv5s423v2">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-172" data-mp="2dk4vpjo37j7o">
          THE SOLUTION YOU'VE BEEN WAITING FOR — A 6-IN-1 SYSTEM
        </h2>
        <p className="text-sm sm:text-base font-subheading font-bold text-brand-rose mb-2" data-id="element-173" data-mp="1auyx7nagkbzo">
          6 guides in 1, designed for dance professionals
        </p>
        <div className="inline-block bg-brand-rose text-white px-3 py-1 rounded mb-2 shadow-sm" data-id="element-174" data-mp="1kmuvozggi44f">
          <p className="font-button font-bold text-sm tracking-wide" data-id="element-175" data-mp="mzmh7oevhvbx">
            Dance Ready 6-in-1 Box Set
          </p>
        </div>
        <p className="text-sm text-brand-taupe font-medium leading-tight" data-id="element-176" data-mp="ry63jpxdp94t">
          DANCE READY™ is much more than a simple manual. It is a complete
          professional operating system that delivers structured, dynamic and
          engaging dance classes — pedagogically designed to guarantee flow,
          confidence and authority in the studio.
        </p>
      </div>

      <div className="flex flex-col gap-2" data-id="element-177" data-mp="2d9xpxfe3nsov">
        {modules.map((module, i) => <div key={i} className="bg-brand-cream border border-brand-beige p-2.5 rounded flex gap-2 items-center shadow-sm" data-id="element-178" data-mp="d87vx2x984hb" data-mpi={i}>
            <div className="text-brand-gold shrink-0" data-id="element-179" data-mp="m9pb8j2u824y">✅</div>
            <div data-id="element-180" data-mp="m95sx199zbqe">
              <h3 className="text-sm font-bold text-brand-taupe leading-tight" data-id="element-181" data-mp="m7l8w5kl7b6s">
                {module.title}
              </h3>
              <p className="text-brand-taupe/80 text-xs font-medium leading-tight" data-id="element-182" data-mp="3qnnr7vn2b49a">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}